import { Input, Popover, DatePicker } from 'element-ui';
import { EventBus } from '@/services/Event.js';
import DisabledValue from '../disabled-value/disabled-value.vue';

export default {
    name: 'DateTimeAnswer',
    props: {
        id: [Number, String],
        value: String,
        label: String,
        label_class: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        visible: {
            type: Boolean, default: true
        },
        hint: String,
        warning_field_length: String,
        error_messages: Array,
        hint_type: { type: String, default: 'warning' },
        preview: { type: Boolean, default: false },
        valid: { type: Boolean, default: true },
        min_length: Number,
        max_length: Number,
        is_mandatory: Boolean,
        is_mandatory_if_visible: Boolean,

        placeholder: { type: String, default: 'value' },
        smallest: { type: String, default: 'col-12' },
        small: { type: String, default: 'col-sm-12' },
        medium: { type: String, default: 'col-md-12' },
        large: { type: String, default: 'col-lg-12' },
        largest: { type: String, default: 'col-lg-12' },

        type: String,
        is_disabled_date_only: true,
        year: Number
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
        [DatePicker.name]: DatePicker,
        'disabled-value': DisabledValue
    },
    computed: {
        label_value() {
            if (!this.prop_value) {
                return "";
            }

            var datetime = this.prop_value.getFullYear() + "-" +
                ((this.prop_value.getMonth() + 1) < 10 ? `0${(this.prop_value.getMonth() + 1)}` : (this.prop_value.getMonth() + 1)) + "-" +
                (this.prop_value.getDate() < 10 ? `0${this.prop_value.getDate()}` : this.prop_value.getDate()) + " " +
                this.formatAMPM(this.prop_value);
            return datetime
        },
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return "float-left"
        },
        pickerOptions() {
            var isDisabledDate = this.is_disabled_date_only;
            var year = this.year;
            var currentDate = this.value ? new Date(this.value) : null;
            var now = new Date();
            //ToDo: new Date() = should be taken from General.Now
            return {
                disabledDate(date) {
                    if (isDisabledDate && currentDate) {
                        return true;
                    }
                    if (year) {
                        return date <= now || date.getFullYear() != year;
                    }

                    return date <= now;
                }
            }
        }
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                if (val) {

                    if (val && this.prop_value && val == this.getDateTimeValidValueString()) {
                        return;
                    }

                    var dateAndTime = val.split("T");

                    if (dateAndTime && dateAndTime.length) {
                        var result = new Date(dateAndTime[0]);
                        var timeArray = dateAndTime[1].split(":");

                        if (timeArray.length > 2) {
                            result.setHours(timeArray[0]);
                            result.setMinutes(timeArray[1]);
                            result.setSeconds(timeArray[2]);

                            this.prop_value = result;
                            return;
                        }
                    }
                }
                this.prop_value = null;
            }
        }
    },
    data() {
        return {
            warning_mandatory: "This field is mandatory to fill",

            prop_value: "",
            prop_valid: true,

        };
    },
    methods: {
        formatAMPM(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        validate() {
            let new_warnings = [];
            if (!this.is_mandatory && !this.is_mandatory_if_visible && !this.prop_value) {
                this.prop_valid = true;
                return;
            }

            if ((this.is_mandatory || this.is_mandatory_if_visible) && !this.prop_value) {
                new_warnings.push(this.warning_mandatory);
            }

            this.prop_valid = !new_warnings.length;
            this.$emit("update:valid", this.prop_valid);
            this.$emit("update:error_messages", new_warnings);
        },
        handler_change() {
            if (this.value && this.prop_value && this.value == this.getDateTimeValidValueString()) {
                return;
            }
            this.validate();
            if (this.prop_value) {
                this.$emit("update:value", this.getDateTimeValidValueString());
            }
            else {
                this.$emit("update:value", null);
            }
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        getDateTimeValidValueString() {
            var monthValue = this.prop_value.getMonth() + 1;
            var month = monthValue < 10 ? '0' + monthValue : monthValue;
            var day = this.prop_value.getDate() < 10 ? '0' + this.prop_value.getDate() : "" + this.prop_value.getDate();
            var hours = this.prop_value.getHours() < 10 ? '0' + this.prop_value.getHours() : "" + this.prop_value.getHours();
            var minutes = this.prop_value.getMinutes() < 10 ? '0' + this.prop_value.getMinutes() : "" + this.prop_value.getMinutes();
            var seconds = this.prop_value.getSeconds() < 10 ? '0' + this.prop_value.getSeconds() : "" + this.prop_value.getSeconds();

            return `${this.prop_value.getFullYear()}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        }
    },
    mounted() {
        this.handler_change();
        this.remove_tab_index();
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/datetime/datetime.js